import FintechOutagesZuoraTooltip from './FintechOutagesZuoraTooltip';
import UnauthorizedTooltip from '../UnauthorizedTooltip';
import { useZuoraAvailability } from '../../hooks/useZuoraAvailability';
import { useAuth } from '../../hooks/useAuth';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const FintechOutagesCheckTooltip = ({
  children,
  rolesToAuthorize = [],
  requiresZuoraAvailability = false,
  DefaultTooltipComponent,
  userInfo
}) => {
  const {
    hasRole,
    userInfo: authObj
  } = useAuth(userInfo);
  const zuoraAvailability = useZuoraAvailability({
    hubId: authObj.portal.portal_id
  });
  if (requiresZuoraAvailability && zuoraAvailability.zuora.isDown) {
    return /*#__PURE__*/_jsx(FintechOutagesZuoraTooltip, {
      zuoraAvailability: zuoraAvailability.zuora,
      children: children
    });
  }
  if (rolesToAuthorize.length > 0 && !rolesToAuthorize.some(role => hasRole(role))) {
    return /*#__PURE__*/_jsx(UnauthorizedTooltip, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: DefaultTooltipComponent ? /*#__PURE__*/_jsx(DefaultTooltipComponent, {
      children: children
    }) : children
  });
};
export default FintechOutagesCheckTooltip;